import React from "react";

const OnlineIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.24"
      height="23.24"
      viewBox="0 0 23.24 23.24"
    >
      <path
        id="db37"
        d="M179.24,167.62a11.62,11.62,0,1,0,11.62,11.624A11.626,11.626,0,0,0,179.24,167.62Zm0,.52a11.083,11.083,0,0,1,2.435.273,5.322,5.322,0,0,0-1.337,1.437.279.279,0,0,0,.223.413,1.948,1.948,0,0,1,1.428.38.971.971,0,0,1,.19.842c-.1.58-.287,1.093-.38,1.626.017.46.23.616.652.652a2.954,2.954,0,0,0,.751-.239v.173a7.083,7.083,0,0,1-.99.85,3.457,3.457,0,0,0-1.386,2.006,2.594,2.594,0,0,0,.281,1.792,1.525,1.525,0,0,0,1.056.627c.784.143,1.62.044,2.17.462a7.591,7.591,0,0,1,.99,2.452,4.262,4.262,0,0,0,1.155,2.32.278.278,0,0,0,.413-.157,3.017,3.017,0,0,1,.652-1.346c.778-.949,1.075-2.052,1.807-3.046a2.5,2.5,0,0,1,.974-.834c.005.14.008.279.008.421a11.092,11.092,0,1,1-21.861-2.617,2.322,2.322,0,0,1,1.271,1.882.268.268,0,0,0,.066.124,5.338,5.338,0,0,1,1.774,4.045.267.267,0,0,0,.058.165c.686.824,1.544,1.484,2.212,2.312a4.953,4.953,0,0,1,1.164,3.335.271.271,0,0,0,.182.248l.792.264a.273.273,0,0,0,.322-.132,7.222,7.222,0,0,0,.272-1.354,8.275,8.275,0,0,1,2.154-3.335,3.692,3.692,0,0,0,1.3-2.824.272.272,0,0,0-.2-.256c-.956-.239-1.738-1.078-2.781-1.635a4.063,4.063,0,0,0-4.11.264,1.762,1.762,0,0,1-.305-1.28.269.269,0,0,0-.115-.223,1.748,1.748,0,0,1-.99-1.428l.429.281a.276.276,0,0,0,.388-.1,7.276,7.276,0,0,1,2.872-2.766,7.934,7.934,0,0,0,2.657-1.973,3.112,3.112,0,0,0-.248-1.99,14.968,14.968,0,0,0-.974-1.808,14.284,14.284,0,0,1,2.583-.305Z"
        transform="translate(-167.62 -167.62)"
        fill={fill ? fill : "#707070"}
      />
    </svg>
  );
};

export default OnlineIcon;
